// Home banner slider
$(document).ready(function(){
    $('.slide-list').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 2000
    });
  });

  // reviews-home  
    $(document).ready(function () {
        $('.reviews-home').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 800,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
            ]
        });
    });

// Logo Slider
$(document).ready(function(){
    $('.logo-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2
                }
            }
            ]
    });
  });